export const getAllCountryImage = (title) => {
   //console.log(title);
  switch (title) {
    case "科威特旅游电子签证":
      return "/assets/country/Kuwait.webp";
    case "印度旅游电子签证":
      return "/assets/country/India.webp";
    case "印度商务电子签证":
      return "/assets/country/India8.webp";
    case "新西兰旅游ETA":
      return "/assets/country/newZealand.webp";
    case "美国旅游 ESTA 签证":
      return "/assets/country/USA.webp";
    case "美国商业 ESTA":
      return "/assets/country/Usa1.webp";
    case "加拿大旅游ETA":
      return "/assets/country/Canada.webp";
    case "澳大利亚电子访客签证":
      return "/assets/country/Australia.webp";

    case "泰国旅游电子签证":
      return "/assets/country/Thailand.webp";

    case "ベトナム観光電子ビザ":
      return "/assets/country/Vietnam.webp";
    case "カンボジア観光電子ビザ":
      return "/assets/country/Cambodia.webp";
    case "インドの観光電子ビザ":
      return "/assets/country/India.webp";
    case "スリランカの観光電子ビザ":
      return "/assets/country/Srilanka.webp";
    case "エジプトの観光電子ビザ":
      return "/assets/country/Egypt.webp";
    case "アゼルバイジャンの観光電子ビザ":
      return "/assets/country/Azerbaijan.webp";
    case "バーレーンの観光電子ビザ":
      return "/assets/country/Bahrein.webp";
    case "ケニアの観光電子ビザ":
      return "/assets/country/Kenya.webp";
    case "クウェートの観光電子ビザ":
      return "/assets/country/Kuwait.webp";
    case "ニュージーランド観光ETA":
      return "/assets/country/newZealand.webp";
    case "サウジアラビアの観光電子ビザ":
      return "/assets/country/Saudi_Arabia.webp";
    case "インドネシアの観光電子ビザ":
      return "/assets/country/Indonesia1.webp";
    case "オマーンの観光電子ビザ":
      return "/assets/country/Oman.webp";
    case "ロシアの観光電子ビザ":
      return "/assets/country/Russia.webp";
    case "米国観光ESTAビザ":
      return "/assets/country/USA.webp";
    case "カナダ観光ETA":
      return "/assets/country/Canada.webp";
    case "オーストラリア e 観光ビザ":
      return "/assets/country/Australia.webp";
    case "تأشيرة فنزويلا السياحية الإلكترونية":
      return "/assets/country/venezuela.webp";
    //5 hONG KONG
    //6 SOUTH KOREA
    //7 PHILIPPNES
    //8 THAILAND
    //9 UNITED KINGDOM
    //10  iNDIA
    case "वियतनाम पर्यटक ई-वीजा":
      return "/assets/country/Vietnam.webp";
    case "कंबोडिया पर्यटक ई-वीजा":
      return "/assets/country/Cambodia.webp";
    case "कंबोडिया बिजनेस ई-वीजा":
      return "/assets/country/Cambodia2.webp";
    case "श्रीलंका पर्यटक ई-वीजा":
      return "/assets/country/Srilanka3.webp";
    case "श्रीलंका व्यापार ई-वीजा":
      return "/assets/country/Srilanka1.webp";
    case "श्रीलंका ट्रांजिट ई-वीजा":
      return "/assets/country/Srilanka2.webp";
    case "मिस्र पर्यटक ई-वीजा":
      return "/assets/country/Egypt.webp";
    case "अज़रबैजान पर्यटक ई-वीजा":
      return "/assets/country/Azerbaijan.webp";
    case "बहरीन पर्यटक ई-वीजा":
      return "/assets/country/Bahrein.webp";
    case "केन्या पर्यटक ई-वीजा":
      return "/assets/country/Kenya.webp";
    case "मलेशिया पर्यटक ई-वीजा":
      return "/assets/country/Malaysia.webp";
    case "रूस पर्यटक ई-वीजा":
      return "/assets/country/Russia.webp";
    case "ऑस्ट्रेलिया ई आगंतुक वीजा":
      return "/assets/country/Australia.webp";
    case "लाओस पर्यटक ई-वीजा":
      return "/assets/country/Laos.webp";
    case "मोरक्को पर्यटक ई-वीजा":
      return "/assets/country/Morocco.webp";
    case "दक्षिण अफ्रीका पर्यटक ई-वीजा":
      return "/assets/country/India7.webp";
    case "अर्मेनिया पर्यटक ई-वीजा":
      return "/assets/country/Armenian.webp";
    case "जॉर्जिया पर्यटक ई-वीजा":
      return "/assets/country/Georgia.webp";
    case "मोल्दोवा पर्यटक ई-वीजा":
      return "/assets/country/Moldova.webp";
    case "ताजिकिस्तान पर्यटक ई-वीजा":
      return "/assets/country/tajikistan.webp";
    case "यूक्रेन पर्यटक ई-वीजा":
      return "/assets/country/Ukraine1.webp";
    case "यूक्रेन पर्यटक ई-वीजा तत्काल प्रवेश":
      return "/assets/country/Ukraine2.webp";
    case "यूक्रेन तत्काल पर्यटक ई-वीजा":
      return "/assets/country/Ukraine3.webp";
    case "यूक्रेन व्यापार ई-वीजा":
      return "/assets/country/Ukraine4.webp";
    case "यूक्रेन तत्काल व्यापार ई-वीजा":
      return "/assets/country/Ukraine4.webp";
    case "यूक्रेन व्यापार तत्काल ई-वीजा":
      return "/assets/country/Ukraine5.webp";
    case "संयुक्त अरब अमीरात पर्यटक ई-वीजा":
      return "/assets/country/UAE.webp";
    case "यूएई पर्यटक ई-वीज़ा":
      return "/assets/country/uae2.webp";
    case "रोमानिया पर्यटक ई-वीजा":
      return "/assets/country/Romania.webp";
    case "इंडोनेशिया पर्यटक ई-वीजा":
      return "/assets/country/Indonesia1.webp";
    case "वेनेजुएला पर्यटक ई-वीजा":
      return "/assets/country/venezuela.webp";
    case "कतर पर्यटक ई-वीजा":
      return "/assets/country/Qatar1.webp";
    case "कतर बिजनेस ई-वीजा":
      return "/assets/country/Qatar3.webp";
    case "थाईलैंड पर्यटक ई-वीजा":
      return "/assets/country/Thailand.webp";
    //11 SRI LANKA
    //12 SOUTH AFRICA
    //13 AUSTRALIA
    //14 KENYA
    //15 KUWAIT
    // 16 MALAYSIA
    // 17 NEW ZEALAND
    //18 SAUDI ARABAI
    //19 TURKEY
    case "Morocco Tourist E-Visa":
      return "/assets/country/moracco1.webp";
    case "Express Morocco Tourist E-Visa":
      return "/assets/country/moracco2.webp";
    case "Laos Turist E-Vizesi":
      return "/assets/country/Laos.webp";
    case "Tayvan Turist E-Vizesi":
      return "/assets/country/Taiwan.webp";
    case "Ermenistan Turist E-Vizesi":
      return "/assets/country/Armenian.webp";
    case "Romanya Turist E-Vizesi":
      return "/assets/country/Romania.webp";
    case "Meksika Turist E-Vizesi":
      return "/assets/country/Maxico.webp";
    case "Endonezya Turist E-Vizesi":
      return "/assets/country/Indonesia1.webp";
    case "Umman Turist E-Vizesi":
      return "/assets/country/Oman.webp";
    //20 UKRAINA
    case "Індійська туристична електронна віза":
      return "/assets/country/India.webp";
    case "Ділова електронна віза Шрі-Ланки":
      return "/assets/country/Srilanka2.webp";
    case "Транзитна електронна віза Шрі-Ланки":
      return "/assets/country/Srilanka.webp";
    case "Туристична електронна віза Шрі-Ланки":
      return "/assets/country/Srilanka3.webp";
    case "Єгипетська туристична електронна віза":
      return "/assets/country/Egypt.webp";
    case "Туристична електронна віза Бахрейну":
      return "/assets/country/Bahrein.webp";
    case "Туристична електронна віза Кенії":
      return "/assets/country/Kenya.webp";
    case "Туристична електронна віза Кувейту":
      return "/assets/country/Kuwait.webp";
    case "Ділова електронна віза в Індію":
      return "/assets/country/India1.webp";
    case "Туристична електронна віза Саудівської Аравії":
      return "/assets/country/Saudi_Arabia.webp";
    case "Туристична електронна віза в Мексику":
      return "/assets/country/Maxico.webp";
    case "Туристична електронна віза Індонезії":
      return "/assets/country/Indonesia1.webp";
    case "Туристична електронна віза Оману":
      return "/assets/country/Oman.webp";
    // 21 UAE
    //22 CANADA
    case "E-visa touristique pour le Vietnam":
      return "/assets/country/Vietnam.webp";
    case "Visa de tourisme pour le Cambodge":
      return "/assets/country/Cambodia.webp";
    case "Visa d&#39;affaires pour le Cambodge":
      return "/assets/country/Cambodia 2.webp";
    case "Visa de tourisme pour l&#39;Inde":
      return "/assets/country/India.webp";
    case "Visa de tourisme pour le Sri Lanka":
      return "/assets/country/Srilanka.webp";
    case "E-visa de transit pour le Sri Lanka":
      return "/assets/country/Srilanka1.webp";
    case "Visa d&#39;affaires pour le Sri Lanka":
      return "/assets/country/Srilanka2.webp";
    case "E-visa de tourisme pour l&#39;Égypte":
      return "/assets/country/Egypt.webp";
    case "E-visa de tourisme pour l&#39;Égypte":
      return "/public/assets/country/";
    case "E-visa de tourisme pour l&#39;Azerbaïdjan":
      return "/assets/country/Azerbaijan.webp";
    case "E-visa de tourisme pour Bahreïn":
      return "/assets/country/Bahrein.webp";
    case "Visa de tourisme pour le Kenya":
      return "/assets/country/Kenya.webp";
    case "E-Visa de tourisme pour le Koweït":
      return "/assets/country/Kuwait.webp";
    case "ETA touristique en Nouvelle-Zélande":
      return "/assets/country/newZealand.webp";
    case "Visa de tourisme pour la Turquie":
      return "/assets/country/Turkey.webp";
    case "VISA ESTA Touristique USA":
      return "/assets/country/USA.webp";
    case "États-Unis Entreprise ESTA":
      return "/assets/country/Usa1.webp";
    case "Australie e Visa de visiteur":
      return "/assets/country/Australia.webp";
    //23 HUNGARY

    case "Vietnami turisztikai e-vízum":
      return "/assets/country/Vietnam.webp";
    case "Kambodzsai turisztikai e-vízum":
      return "/assets/country/Cambodia.webp";
    case "Kambodzsa üzleti E-Visa":
      return "/assets/country/Cambodia 2.webp";
    case "India turisztikai e-vízum":
      return "/assets/country/India.webp";
    case "Sri Lanka turisztikai e-vízum":
      return "/assets/country/Srilanka.webp";
    case "Egyiptom turista E-Visa":
      return "/assets/country/Egypt.webp";
    case "Ausztrália e Visitor Visa":
      return "/assets/country/Australia.webp";
    case "Azerbajdzsán Tourist E-Visa":
      return "/assets/country/Azerbaijan.webp";
    case "Bahrein Tourist E-Visa":
      return "/assets/country/Bahrein.webp";
    case "Kuvaiti turisztikai e-vízum":
      return "/assets/country/Kuwait.webp";
    case "USA turista ESTA VISA":
      return "/assets/country/USA.webp";
    case "Új-zélandi turisztikai ETA":
      return "/assets/country/newZealand.webp";
    case "Kanada Touristen ETA":
      return "/assets/country/Canada.webp";
    case "ESTA-Visum für Touristen in den USA":
      return "/assets/country/USA.webp";
    case "E-Visum für Touristen für Russland":
      return "/assets/country/Russia.webp";
    case "Touristen-E-Visum für Kenia":
      return "/assets/country/Kenya.webp";
    case "Elektronisches Touristenvisum für Kuwait":
      return "/assets/country/Kuwait.webp";
    case "ETA für Touristen in Neuseeland":
      return "/assets/country/newZealand.webp";
    case "E-Visum für Touristen für Bahrain":
      return "/assets/country/Bahrein.webp";
    case "Touristen-E-Visum für Aserbaidschan":
      return "/assets/country/Azerbaijan.webp";
    case "Australien e Besuchervisum":
      return "/assets/country/Australia.webp";
    case "Elektronisches Touristenvisum für Indien":
      return "/assets/country/India.webp";
    case "E-Visum für Indien":
      return "/assets/country/India6.webp";
    case "Elektronisches Touristenvisum für Sri Lanka":
      return "/assets/country/Srilanka.webp";
    case "Sri Lanka Business E-Visum":
      return "/assets/country/Srilanka2.webp";
    case "E-Visum für Touristen für Saudi-Arabien":
      return "/assets/country/Saudi_Arabia.webp";
    case "Oman Touristen-E-Visum":
      return "/assets/country/Oman.webp";
    case "Elektronisches Touristenvisum für Indonesien":
      return "/assets/country/Indonesia1.webp";
    case "Sri Lanka Transit-E-Visum":
      return "/assets/country/Srilanka3.webp";
    case "E-Visum für Touristen für Ägypten":
      return "/assets/country/Egypt.webp";
    case "Elektronisches Touristenvisum für Vietnam":
      return "/assets/country/Vietnam.webp";
    case "Touristen-E-Visum für Laos":
      return "/assets/country/Laos.webp";
    case "Elektronisches Touristenvisum für Kambodscha":
      return "/assets/country/Cambodia.webp";
    case "Kambodscha Business E-Visum":
      return "/assets/country/Cambodia1.webp";
    //23 HUNGARY
    //24 AUSTRIA
    //25 SERBIA
    //26 SWITZERLAND
    //27 GERMANY
    //28  ISRAEL
    case "ויזה אלקטרונית לתיירים אזרבייג&#39;ן":
      return "/assets/country/Azerbaijan.webp";
    case "ויזה אלקטרונית לתייר בבחריין":
      return "/assets/country/Bahrein.webp";
    case "ויזה אלקטרונית לתיירים לקניה":
      return "/assets/country/Kenya.webp";
    case "ניו זילנד תיירות ETA":
      return "/assets/country/newZealand.webp";
    case "קנדה תיירות ETA":
      return "/assets/country/Canada.webp";
    case "ויזה אלקטרונית לתייר של טג&#39;יקיסטן":
      return "/assets/country/tajikistan.webp";
    case "ויזה אלקטרונית לתיירים של ארמניה":
      return "/assets/country/Armenian.webp";
    case "ויזה אלקטרונית לתיירים למרוקו":
      return "/assets/country/Morocco.webp";
    //27  BULGARRIA
    case "Виетнамска туристическа електронна виза":
      return "/assets/country/Vietnam.webp";
    case "Туристическа електронна виза за Камбоджа":
      return "/assets/country/Cambodia.webp";
    case "Индийска туристическа електронна виза":
      return "/assets/country/India.webp";
    case "Туристическа електронна виза за Шри Ланка":
      return "/assets/country/Srilanka.webp";
    case "Бизнес електронна виза за Шри Ланка":
      return "/assets/country/Srilanka1.webp";
    case "Транзитна електронна виза за Шри Ланка":
      return "/assets/country/Srilanka2.webp";
    case "Египетска туристическа електронна виза":
      return "/assets/country/Egypt.webp";
    case "Австралийска е посетителска виза":
      return "/assets/country/Australia.webp";
    case "Азербайджанска туристическа електронна виза":
      return "/assets/country/Azerbaijan.webp";
    case "Туристическа електронна виза за Бахрейн":
      return "/assets/country/Bahrein.webp";
    case "Туристическа електронна виза за Кения":
      return "/assets/country/Kenya.webp";
    case "Кувейтска туристическа електронна виза":
      return "/assets/country/Kuwait.webp";
    case "Новозеландски туристически ETA":
      return "/assets/country/newZealand.webp";
    case "Електронна туристическа виза за Русия":
      return "/assets/country/Russia.webp";
    case "ESTA туристическа виза за САЩ":
      return "/assets/country/USA.webp";
    case "Бизнес ESTA в САЩ":
      return "/assets/country/Usa1.webp";
    case "Канадски туристически ETA":
      return "/assets/country/Canada.webp";
    case "Бизнес електронна виза за Индия":
      return "/assets/country/India1.webp";
    case "Лаоска туристическа електронна виза":
      return "/assets/country/Laos.webp";
    case "Електронна туристическа виза за Саудитска Арабия":
      return "/assets/country/Saudi_Arabia.webp";
    case "Индонезийска туристическа електронна виза":
      return "/assets/country/Indonesia1.webp";
    case "Туристическа електронна виза за Оман":
      return "/assets/country/Oman.webp";
    case "Бизнес електронна виза за Камбоджа":
      return "/assets/country/Cambodia 2.webp";
    //28 FRANCE
    case "Visa d&#39;affaires pour l&#39;Inde":
      return "/assets/country/India1.webp";
    //29 ITALY

    case "Visto turistico elettronico per il Vietnam":
      return "/assets/country/Vietnam.webp";
    case "Visto elettronico turistico per la Cambogia":
      return "/assets/country/Cambodia.webp";
    case "Visto elettronico per affari per la Cambogia":
      return "/assets/country/Cambodia1.webp";
    case "Visto elettronico turistico per l&#39;India":
      return "/assets/country/India.webp";
    case "Visto elettronico per affari per l&#39;India":
      return "/assets/country/India1.webp";
    case "Visto elettronico per lo Sri Lanka":
      return "/assets/country/Srilanka.webp";
    case "Visto elettronico di transito per lo Sri Lanka":
      return "/assets/country/Srilanka2.webp";
    case "Visto elettronico per affari dello Sri Lanka":
      return "/assets/country/Srilanka1.webp";
    case "Visto turistico elettronico per l&#39;Egitto":
      return "/assets/country/Egypt.webp";
    case "Australia e Visto turistico":
      return "/assets/country/Australia.webp";
    case "Visto turistico elettronico per l&#39;Azerbaigian":
      return "/assets/country/Azerbaijan.webp";
    case "Visto turistico elettronico per il Bahrein":
      return "/assets/country/Bahrein.webp";
    case "Visto turistico elettronico per il Kenya":
      return "/assets/country/Kenya.webp";
    case "Visto turistico elettronico per il Kuwait":
      return "/assets/country/Kuwait.webp";
    case "ETA turistico neozelandese":
      return "/assets/country/newZealand.webp";
    case "Visto turistico elettronico per la Russia":
      return "/assets/country/Russia.webp";
    case "Visto turistico ESTA USA":
      return "/assets/country/USA.webp";
    case "ETA turistico canadese":
      return "/assets/country/Canada.webp";
    case "Visto turistico elettronico per il Laos":
      return "/assets/country/Laos.webp";
    case "Visto turistico elettronico per l&#39;Arabia Saudita":
      return "/assets/country/Saudi_Arabia.webp";
    case "Visto elettronico per l&#39;Indonesia":
      return "/assets/country/Indonesia1.webp";
    case "Visto turistico elettronico per l&#39;Oman":
      return "/assets/country/Oman.webp";
    //30 DENMARK

    case "Vietnam turist e-visum":
      return "/assets/country/Vietnam.webp";
    case "Cambodja turist e-visum":
      return "/assets/country/Cambodia.webp";
    case "Cambodja Business E-visum":
      return "/assets/country/Cambodia1.webp";
    case "Indien turist e-visum":
      return "/assets/country/India.webp";
    case "Indien Business E-Visa":
      return "/assets/country/India1.webp";
    case "Sri Lanka turist e-visum":
      return "/assets/country/Srilanka.webp";
    case "Sri Lanka Business E-Visa":
      return "/assets/country/Srilanka1.webp";
    case "Sri Lanka Transit E-visum":
      return "/assets/country/Srilanka2.webp";
    case "Egyptens turist e-visum":
      return "/assets/country/Egypt.webp";
    case "Australien e Besøgsvisum":
      return "/assets/country/Australia.webp";
    case "Aserbajdsjan turist e-visum":
      return "/assets/country/Azerbaijan.webp";
    case "Bahrain turist e-visum":
      return "/assets/country/Bahrein.webp";
    case "Kenya turist e-visum":
      return "/assets/country/Kenya.webp";
    case "Kuwait turist e-visum":
      return "/assets/country/Kuwait.webp";
    case "Laos turist e-visum":
      return "/assets/country/Laos.webp";
    case "Saudi-Arabien turist e-visum":
      return "/assets/country/Saudi_Arabia.webp";
    case "Rusland turist e-visum":
      return "/assets/country/Russia.webp";
    case "Indonesien turist e-visum":
      return "/assets/country/Indonesia1.webp";
    case "Oman turist e-visum":
      return "/assets/country/Oman.webp";
    case "USA turist ESTA VISA":
      return "/assets/country/USA.webp";
    //31 slovakia
    case "Vietnamské turistické elektronické vízum":
      return "/assets/country/Vietnam.webp";
    case "Laosské turistické elektronické vízum":
      return "/assets/country/Laos.webp";
    case "Kambodžské turistické elektronické vízum":
      return "/assets/country/Cambodia.webp";
    case "Kambodžské obchodné e-vízum":
      return "/assets/country/Cambodia1.webp";
    case "Indické turistické elektronické vízum":
      return "/assets/country/India.webp";
    case "Obchodné E-víza v Indii":
      return "/assets/country/India1.webp";
    case "Turistické elektronické víza Srí Lanky":
      return "/assets/country/Srilanka.webp";
    case "Obchodné elektronické víza Srí Lanky":
      return "/assets/country/Srilanka1.webp";
    case "Srílanské tranzitné elektronické vízum":
      return "/assets/country/Srilanka2.webp";
    case "Egyptské turistické elektronické vízum":
      return "/assets/country/Egypt.webp";
    case "Austrália a návštevnícke víza":
      return "/assets/country/Australia.webp";
    case "Azerbajdžanské turistické elektronické víza":
      return "/assets/country/Azerbaijan.webp";
    case "Bahrajnské turistické elektronické vízum":
      return "/assets/country/Bahrein.webp";
    case "Keňa turistické elektronické vízum":
      return "/assets/country/Kenya.webp";
    case "Kuvajtské turistické elektronické vízum":
      return "/assets/country/Kuwait.webp";
    case "Turistický ETA na Novom Zélande":
      return "/assets/country/newZealand.webp";
    case "Saudská Arábia turistické E-vízum":
      return "/assets/country/Saudi_Arabia.webp";
    case "Ruské turistické elektronické vízum":
      return "/assets/country/Russia.webp";
    case "Indonézske turistické elektronické vízum":
      return "/assets/country/Indonesia1.webp";
    case "Ománske turistické elektronické vízum":
      return "/assets/country/Oman.webp";
    case "USA turistické ESTA VISA":
      return "/assets/country/USA.webp";
    case "Kanadský turistický ETA":
      return "/assets/country/Canada.webp";
    case "Szaúd-Arábia turisztikai e-vízuma":
      return "/assets/country/Saudi_Arabia.webp";
    case "Indonéziai turisztikai e-vízum":
      return "/assets/country/Indonesia1.webp";
    case "Laos Tourist E-Visa":
      return "/assets/country/Laos.webp";
    //32 Norway

    case "Kambodsja turist e-visum":
      return "/assets/country/Cambodia.webp";
    case "India turist e-visum":
      return "/assets/country/India.webp";
    case "India Business E-visum":
      return "/assets/country/India5.webp";
    case "Egypt turist e-visum":
      return "/assets/country/Egypt.webp";
    case "Australia e besøksvisum":
      return "/assets/country/Australia.webp";
    case "Saudi-Arabia turist e-visum":
      return "/assets/country/Saudi_Arabia.webp";
    case "Russland turist e-visum":
      return "/assets/country/Russia.webp";
    case "Indonesia turist e-visum":
      return "/assets/country/Indonesia1.webp";
    // 33 ireland
    //spain
    case "Visa electrónica de turista de Laos":
      return "/assets/country/Laos.webp";
    case "Visa electrónica de turista para Kenia":
      return "/assets/country/Kenya.webp";
    case "Visa electrónica de turista para Kuwait":
      return "/assets/country/Kuwait.webp";
    case "Visa electrónica de turista para Arabia Saudita":
      return "/assets/country/Saudi_Arabia.webp";
    case "Visa electrónica de turista para Indonesia":
      return "/assets/country/Indonesia1.webp";
    case "Visa electrónica de turista para Omán":
      return "/assets/country/Oman.webp";
    case "ESTA de negocios de EE. UU.":
      return "/assets/country/Usa1.webp";
    // croatia
    //36 poland

    case "E-Visa turystyczna do Wietnamu":
      return "/assets/country/Vietnam.webp";
    case "E-Visa turystyczna do Laosu":
      return "/assets/country/Laos.webp";
    case "E-Visa turystyczna do Kambodży":
      return "/assets/country/Cambodia.webp";
    case "E-Visa biznesowa do Kambodży":
      return "/assets/country/Cambodia1.webp";
    case "E-wiza turystyczna do Indii":
      return "/assets/country/India.webp";
    case "E-wiza biznesowa do Indii":
      return "/assets/country/India3.webp";
    case "E-Visa turystyczna do Sri Lanki":
      return "/assets/country/Srilanka.webp";
    case "Biznesowa e-Visa do Sri Lanki":
      return "/assets/country/Srilanka1.webp";
    case "E-Visa tranzytowa do Sri Lanki":
      return "/assets/country/Srilanka2.webp";
    case "E-Visa turystyczna do Egiptu":
      return "/assets/country/Egypt.webp";
    case "Australia i wiza turystyczna":
      return "/assets/country/Australia.webp";
    case "Turystyczna e-Visa do Azerbejdżanu":
      return "/assets/country/Azerbaijan.webp";
    case "Turystyczna e-Visa do Bahrajnu":
      return "/assets/country/Bahrein.webp";
    case "E-Visa turystyczna do Kenii":
      return "/assets/country/Kenya.webp";
    case "E-Visa turystyczna do Kuwejtu":
      return "/assets/country/Kuwait.webp";
    case "ETA turystyczna w Nowej Zelandii":
      return "/assets/country/newZealand.webp";
    case "E-Visa turystyczna do Arabii Saudyjskiej":
      return "/assets/country/Saudi_Arabia.webp";
    case "E-wiza turystyczna do Rosji":
      return "/assets/country/Russia.webp";
    case "E-Visa turystyczna do Indonezji":
      return "/assets/country/Indonesia1.webp";
    case "Turystyczna e-Visa do Omanu":
      return "/assets/country/Oman.webp";
    case "Wiza turystyczna ESTA do USA":
      return "/assets/country/USA.webp";
    case "Kanadyjska turystyczna ETA":
      return "/assets/country/Canada.webp";
    //36 Lithuania

    case "Vietnamo turistinė elektroninė viza":
      return "/assets/country/Vietnam.webp";
    case "Laoso turistinė elektroninė viza":
      return "/assets/country/Laos.webp";
    case "Kambodžos turistinė elektroninė viza":
      return "/assets/country/Cambodia.webp";
    case "Kambodžos verslo elektroninė viza":
      return "/assets/country/Cambodia1.webp";
    case "Indijos turistinė elektroninė viza":
      return "/assets/country/India.webp";
    case "Indijos verslo elektroninė viza":
      return "/assets/country/India1.webp";
    case "Šri Lankos verslo elektroninė viza":
      return "/assets/country/Srilanka1.webp";
    case "Šri Lankos tranzitinė elektroninė viza":
      return "/assets/country/Srilanka2.webp";
    case "Šri Lankos turistinė elektroninė viza":
      return "/assets/country/Srilanka.webp";
    case "Egipto turistinė elektroninė viza":
      return "/assets/country/Egypt.webp";
    case "Australijos e lankytojų viza":
      return "/assets/country/Australia.webp";
    case "Azerbaidžano turistinė elektroninė viza":
      return "/assets/country/Azerbaijan.webp";
    case "Bahreino turistinė elektroninė viza":
      return "/assets/country/Bahrein.webp";
    case "Kenijos turistinė elektroninė viza":
      return "/assets/country/Kenya.webp";
    case "Kuveito turistinė elektroninė viza":
      return "/assets/country/Kuwait.webp";
    case "Naujosios Zelandijos turistinis ETA":
      return "/assets/country/newZealand.webp";
    case "Saudo Arabijos turistinė elektroninė viza":
      return "/assets/country/Saudi_Arabia.webp";
    case "Rusijos turistinė elektroninė viza":
      return "/assets/country/Russia.webp";
    case "Indonezijos turistinė elektroninė viza":
      return "/assets/country/Indonesia1.webp";
    case "Omano turistinė elektroninė viza":
      return "/assets/country/Oman.webp";
    case "JAV turistinė ESTA VISA":
      return "/assets/country/USA.webp";
    case "JAV verslo ESTA":
      return "/assets/country/Usa1.webp";
    case "Kanados turistinis ETA":
      return "/assets/country/Canada.webp";
    //36 Romania

    case "Viză electronică turistică pentru Vietnam":
      return "/assets/country/Vietnam.webp";
    case "E-Viză turistică pentru Laos":
      return "/assets/country/Laos.webp";
    case "E-Viză turistică pentru Cambodgia":
      return "/assets/country/Cambodia.webp";
    case "E-Visa de afaceri pentru Cambodgia":
      return "/assets/country/Cambodia1.webp";
    case "Viză electronică turistică pentru India":
      return "/assets/country/India.webp";
    case "E-Visa de afaceri pentru India":
      return "/assets/country/India3.webp";
    case "E-Visa turistica pentru Sri Lanka":
      return "/assets/country/Srilanka.webp";
    case "E-Visa de afaceri pentru Sri Lanka":
      return "/assets/country/Srilanka1.webp";
    case "E-Visa de tranzit pentru Sri Lanka":
      return "/assets/country/Srilanka2.webp";
    case "E-Visa turistica pentru Egipt":
      return "/assets/country/Egypt.webp";
    case "Australia e Viza de vizitator":
      return "/assets/country/Australia.webp";
    case "E-Visa turistica pentru Azerbaidjan":
      return "/assets/country/Azerbaijan.webp";
    case "E-Visa turistica pentru Bahrain":
      return "/assets/country/Bahrein.webp";
    case "Viză electronică turistică pentru Kenya":
      return "/assets/country/Kenya.webp";
    case "E-Visa turistica pentru Kuweit":
      return "/assets/country/Kuwait.webp";
    case "ETA Turistică din Noua Zeelandă":
      return "/assets/country/newZealand.webp";
    case "E-Visa turistica pentru Arabia Saudita":
      return "/assets/country/Saudi_Arabia.webp";
    case "E-Visa turistica pentru Rusia":
      return "/assets/country/Russia.webp";
    case "Viză electronică turistică pentru Indonezia":
      return "/assets/country/Indonesia1.webp";
    case "E-Viză turistică pentru Oman":
      return "/assets/country/Oman.webp";
    case "VISA ESTA Turist SUA":
      return "/assets/country/USA.webp";
    case "SUA Business ESTA":
      return "/assets/country/Usa1.webp";
    case "Canada Turist ETA":
      return "/assets/country/Canada.webp";
    //37 Latvia

    case "Vjetnamas tūristu e-vīza":
      return "/assets/country/Vietnam.webp";
    case "Laosas tūristu e-vīza":
      return "/assets/country/Laos.webp";
    case "Kambodžas tūristu e-vīza":
      return "/assets/country/Cambodia.webp";
    case "Kambodžas biznesa e-vīza":
      return "/assets/country/Cambodia1.webp";
    case "Indijas tūristu e-vīza":
      return "/assets/country/India.webp";
    case "Indijas biznesa e-vīza":
      return "/assets/country/India2.webp";
    case "Šrilankas tūristu e-vīza":
      return "/assets/country/Srilanka.webp";
    case "Šrilankas tranzīta e-vīza":
      return "/assets/country/Srilanka1.webp";
    case "Šrilankas biznesa e-vīza":
      return "/assets/country/Srilanka2.webp";
    case "Ēģiptes tūristu e-vīza":
      return "/assets/country/Egypt.webp";
    case "Austrālijas e apmeklētāju vīza":
      return "/assets/country/Australia.webp";
    case "Azerbaidžānas tūristu e-vīza":
      return "/assets/country/Azerbaijan.webp";
    case "Bahreinas tūristu e-vīza":
      return "/assets/country/Bahrein.webp";
    case "Kenijas tūristu e-vīza":
      return "/assets/country/Kenya.webp";
    case "Kuveitas tūristu e-vīza":
      return "/assets/country/Kuwait.webp";
    case "Jaunzēlandes tūristu ETA":
      return "/assets/country/newZealand.webp";
    case "Saūda Arābijas tūristu e-vīza":
      return "/assets/country/Saudi_Arabia.webp";
    case "Krievijas tūristu e-vīza":
      return "/assets/country/Russia.webp";
    case "Indonēzijas tūristu e-vīza":
      return "/assets/country/Indonesia1.webp";
    case "Omānas tūristu e-vīza":
      return "/assets/country/Oman.webp";
    case "ASV tūristu ESTA VISA":
      return "/assets/country/USA.webp";
    case "ASV biznesa ESTA":
      return "/assets/country/Usa1.webp";
    case "Kanādas tūristu ETA":
      return "/assets/country/Canada.webp";
    // 38 Netherlands
    case "E-Toeristenvisum voor Vietnam":
      return "/assets/country/Vietnam.webp";
    case "Laos e-toeristenvisum":
      return "/assets/country/Laos.webp";
    case "E-Toeristenvisum voor Cambodja":
      return "/assets/country/Cambodia.webp";
    case "E-Zakenvisum Cambodja":
      return "/assets/country/Cambodia1.webp";
    case "E-Toeristenvisum voor India":
      return "/assets/country/India.webp";
    case "E-Zakenvisum voor India":
      return "/assets/country/India1.webp";
    case "E-Toeristenvisum voor Sri Lanka":
      return "/assets/country/Srilanka.webp";
    case "E-Toeristenvisum voor Egypte":
      return "/assets/country/Egypt.webp";
    case "Australië e bezoekersvisum":
      return "/assets/country/Australia.webp";
    case "E-Toeristenvisum voor Azerbeidzjan":
      return "/assets/country/Azerbaijan.webp";
    case "E-Toeristenvisum voor Bahrein":
      return "/assets/country/Bahrein.webp";
    case "E-Toeristenvisum Kenia":
      return "/assets/country/Kenya.webp";
    case "E-Toeristenvisum voor Koeweit":
      return "/assets/country/Kuwait.webp";
    case "Toeristen ETA Nieuw-Zeeland":
      return "/assets/country/newZealand.webp";
    case "E-Toeristenvisum Saoedi-Arabië":
      return "/assets/country/Saudi_Arabia.webp";
    case "E-Toeristenvisum voor Rusland":
      return "/assets/country/Russia.webp";
    case "E-Toeristenvisum voor Indonesië":
      return "/assets/country/Indonesia1.webp";
    case "E-Toeristenvisum voor Oman":
      return "/assets/country/Oman.webp";
    case "VS Toeristen ESTA VISA":
      return "/assets/country/USA.webp";
    case "Zakelijk ESTA VS":
      return "/assets/country/Usa1.webp";
    case "Toeristen ETA Canada":
      return "/assets/country/Canada.webp";
    // 39 Rusia
    //40 Belgium
    case "E-visa de tourisme pour le Laos":
      return "/assets/country/Laos.webp";
    case "E-Visa de tourisme pour l&#39;Arabie Saoudite":
      return "/assets/country/Saudi_Arabia.webp";
    case "E-Visa de tourisme pour la Russie":
      return "/assets/country/Russia.webp";
    case "Visa touristique électronique pour l&#39;Indonésie":
      return "/assets/country/Indonesia1.webp";
    case "E-visa de tourisme pour Oman":
      return "/assets/country/Oman.webp";
    case "ETA de tourisme au Canada":
      return "/assets/country/Canada.webp";
    case "E-transitvisum voor Sri Lanka":
      return "/assets/country/Srilanka2.webp";
    case "E-Zakenvisum voor Sri Lanka":
      return "/assets/country/Srilanka1.webp";
    //41 Czech Republic
    //42 Greece

    case "Τουριστική ηλεκτρονική θεώρηση Βιετνάμ":
      return "/assets/country/Vietnam.webp";
    case "Τουριστική ηλεκτρονική θεώρηση του Λάος":
      return "/assets/country/Laos.webp";
    case "Τουριστική Ηλεκτρονική Βίζα Καμπότζης":
      return "/assets/country/Cambodia.webp";
    case "Επιχειρηματική ηλεκτρονική θεώρηση Καμπότζης":
      return "/assets/country/Cambodia1.webp";
    case "Τουριστική Ηλεκτρονική Βίζα Ινδίας":
      return "/assets/country/India.webp";
    case "Τουριστική ηλεκτρονική θεώρηση της Σρι Λάνκα":
      return "/assets/country/Srilanka.webp";
    case "Σρι Λάνκα Business E-Visa":
      return "/assets/country/Srilanka1.webp";
    case "Τουριστική Ηλεκτρονική Βίζα Αιγύπτου":
      return "/assets/country/Egypt.webp";
    case "Αυστραλία e Visitor Visa":
      return "/assets/country/Australia.webp";
    case "Τουριστική ηλεκτρονική θεώρηση του Αζερμπαϊτζάν":
      return "/assets/country/Azerbaijan.webp";
    case "Τουριστική ηλεκτρονική θεώρηση του Μπαχρέιν":
      return "/assets/country/Bahrein.webp";
    case "Τουρίστας ΗΠΑ ESTA":
      return "/assets/country/USA.webp";
    case "Τουριστική ηλεκτρονική θεώρηση του Ομάν":
      return "/assets/country/Oman.webp";
    case "Τουριστική Ηλεκτρονική Βίζα Σαουδικής Αραβίας":
      return "/assets/country/Saudi_Arabia.webp";
    case "Τουριστική ηλεκτρονική θεώρηση της Ρωσίας":
      return "/assets/country/Russia.webp";
    case "Τουριστική ηλεκτρονική βίζα Ινδονησίας":
      return "/assets/country/Indonesia1.webp";
    case "Τουριστική ΕΤΑ της Νέας Ζηλανδίας":
      return "/assets/country/newZealand.webp";
    case "Τουριστική ηλεκτρονική βίζα Κουβέιτ":
      return "/assets/country/Kuwait.webp";
    case "Τουριστική Ηλεκτρονική Βίζα Κένυας":
      return "/assets/country/Kenya.webp";
    //43 Portugal
    case "E-Visa de trânsito do Sri Lanka":
      return "/assets/country/Srilanka1.webp";
    case "Visto eletrônico de negócios do Sri Lanka":
      return "/assets/country/Srilanka2.webp";
    case "Visto eletrônico laosiano de turista":
      return "/assets/country/Laos.webp";
    case "Austrália e visto de visitante":
      return "/assets/country/Australia.webp";
    case "E-Visa de turista para o Kuwait":
      return "/assets/country/Kuwait.webp";
    case "Arábia Saudita E-Visa de turista":
      return "/assets/country/Saudi_Arabia.webp";
    case "Rússia E-Visa de turista":
      return "/assets/country/Russia.webp";
    case "ESTA Empresarial dos EUA":
      return "/assets/country/Usa1.webp";
    case "Visto eletrônico de turista para a Indonésia":
      return "/assets/country/Indonesia1.webp";
    case "E-Visa omã de turista":
      return "/assets/country/Oman.webp";
    case "VISA ESTA de turista nos EUA":
      return "/assets/country/USA.webp";
    case "Canadá Turismo ETA":
      return "/assets/country/Canada.webp";
    case "Visto eletrônico cambojano de negócios":
      return "/assets/country/Cambodia1.webp";
    case "Visto eletrônico indiano de negócios":
      return "/assets/country/India1.webp";
    //44 Sweden
    case "Kambodja turist E-visum":
      return "/assets/country/Cambodia.webp";
    case "Kambodja Business E-visum":
      return "/assets/country/Cambodia1.webp";
    case "Australien e besöksvisum":
      return "/assets/country/Australia.webp";
    case "Sri Lanka Transit E-Visum":
      return "/assets/country/Srilanka1.webp";
    case "Indien Business E-visum":
      return "/assets/country/India1.webp";
    case "Azerbajdzjan turist e-visum":
      return "/assets/country/Azerbaijan.webp";
    case "Kenya turist E-visum":
      return "/assets/country/Kenya1.webp";
    case "Nya Zeelands turist ETA":
      return "/assets/country/newZealand.webp";
    case "Saudiarabiens turist E-visum":
      return "/assets/country/Saudi_Arabia.webp";
    case "Ryssland turist E-visum":
      return "/assets/country/Russia.webp";
    case "Indonesiens turist e-visum":
      return "/assets/country/Indonesia1.webp";
    case "Kanada Tourist ETA":
      return "/assets/country/Canada.webp";
    //44 Mexico
    case "Visa electrónica de turista para Sudáfrica":
      return "/assets/country/Cambodia1.webp";
    case "Visa electrónica de turista para Armenia":
      return "/assets/country/Armenian.webp";
    case "Visa electrónica de turista para Tayikistán":
      return "/assets/country/tajikistan.webp";
    case "Visa electrónica de turista para Turquía":
      return "/assets/country/Turkey.webp";
    case "Visa electrónica de turista para Ucrania":
      return "/assets/country/Ukraine1.webp";
    case "Visa electrónica de turista para Tailandia":
      return "/assets/country/Thailand.webp";
    case "Visa electrónica de negocios de Camboya":
      return "/assets/country/Cambodia2.webp";
    case "Visa electrónica de negocios de la India":
      return "/assets/country/India1.webp";
    case "Visa electrónica de negocios de Sri Lanka":
      return "/assets/country/Srilanka1.webp";
    case "Visa electrónica de tránsito de Sri Lanka":
      return "/assets/country/Srilanka2.webp";
    //44 Brazil

    case "E-Visa de turista para o Tadjiquistão":
      return "/assets/country/tajikistan.webp";
    // 45 Finland
    case "Laosin turistiviisumi":
      return "/assets/country/Laos.webp";
    case "Saudi-Arabian turisti E-Visa":
      return "/assets/country/Saudi_Arabia.webp";
    case "Indonesian turistiviisumi":
      return "/assets/country/Indonesia1.webp";
    case "Oman Tourist E-Visa":
      return "/assets/country/Oman.webp";
    case "Intian liiketoiminnan sähköinen viisumi":
      return "/assets/country/India1.webp";
    case "Sri Lankan kauttakulku E-Visa":
      return "/assets/country/Srilanka2.webp";
    case "Sri Lankan turisti E-Visa":
      return "/assets/country/srilanka3.webp";
    //46 China
    case "老挝旅游电子签证":
      return "/assets/country/Laos.webp";
    case "南非旅游电子签证":
      return "/assets/country/South Africa.webp";
    case "格鲁吉亚旅游电子签证":
      return "/assets/country/Georgia.webp";
    case "摩尔多瓦旅游电子签证":
      return "/assets/country/Moldova1.webp";
    case "沙特阿拉伯旅游电子签证":
      return "/assets/country/Saudi_Arabia.webp";
    case "塔吉克斯坦旅游电子签证":
      return "/assets/country/tajikistan.webp";
    case "乌克兰旅游电子签证":
      return "/assets/country/Ukraine1.webp";
    case "乌克兰旅游电子签证紧急入境":
      return "/assets/country/Ukraine2.webp";
    case "乌克兰紧急旅游电子签证":
      return "/assets/country/Ukraine3.webp";
    case "乌克兰商务电子签证":
      return "/assets/country/Ukraine4.webp";
    case "乌克兰紧急商务电子签证":
      return "/assets/country/Ukraine5.webp";
    case "乌克兰商务紧急电子签证":
      return "/assets/country/Ukraine6.webp";
    case "印度尼西亚旅游电子签证":
      return "/assets/country/Indonesia1.webp";
    case "罗马尼亚旅游电子签证":
      return "/assets/country/Romania.webp";
    case "智利旅游电子签证":
      return "/assets/country/Chile.webp";
    case "委内瑞拉旅游电子签证":
      return "/assets/country/venezuela.webp";
    case "阿曼旅游电子签证":
      return "/assets/country/Oman.webp";
    case "卡塔尔旅游电子签证":
      return "/assets/country/Qatar1.webp";
    case "卡塔尔商务电子签证":
      return "/assets/country/Qatar3.webp";
    //46 Indonesia
    //chile
    case "Visa electrónica de turista de Venezuela":
      return "/assets/country/venezuela.webp";
    // default
    case "United Kingdom EVW":
      return "/assets/country/UnitedKingdom.webp";
    case "E-Visa Pelancong Arab Saudi":
      return "/assets/country/Saudi_Arabia.webp";
    case "E-Visa Pelancong Ukraine":
      return "/assets/country/Ukraine1.webp";
    case "E-Visa Perniagaan Ukraine":
      return "/assets/country/Ukraine3.webp";
    case "E-Visa Pelancong Urgent Ukraine":
      return "/assets/country/Ukraine4.webp";
    case "E-Visa Perniagaan Segera Ukraine":
      return "/assets/country/Ukraine5.webp";
    case "E-Visa Urgent Perniagaan Ukraine":
      return "/assets/country/Ukraine2.webp";
    case "E-Visa Pelancong Oman":
      return "/assets/country/Oman.webp";
    case "Kemasukan Segera E-Visa Pelancong Ukraine":
      return "/assets/country/Ukraine6.webp";
    case "Vietnam Tourist E-Visa":
      return "/assets/country/Vietnam.webp";
    case "Cambodia Tourist E-Visa":
      return "/assets/country/Cambodia.webp";
    case "Cambodia Business E-Visa":
      return "/assets/country/Cambodia1.webp";
    case "Sri Lanka Tourist E-Visa":
      return "/assets/country/Srilanka.webp";
    case "E-Visa Pelancong Sri Lanka":
      return "/assets/country/Srilanka.webp";
    case "E-Visa Pelancong Georgia":
      return "/assets/country/Georgia.webp";
    case "E-Visa Pelancong Moldova":
      return "/assets/country/Moldova1.webp";
    case "E-Visa Perniagaan Sri Lanka":
      return "/assets/country/Srilanka2.webp";
    case "E-Visa Transit Sri Lanka":
      return "/assets/country/srilanka3.webp";
    case "E-Visa Pelancong Armenia":
      return "/assets/country/Armenian.webp";
    case "Egypt Tourist E-Visa":
      return "/assets/country/Egypt.webp";
    case "Azerbaijan Tourist E-Visa":
      return "/assets/country/Azerbaijan.webp";
    case "E-Visa Pelancong Azerbaijan":
      return "/assets/country/Azerbaijan.webp";
    case "Kenya Tourist E-Visa":
      return "/assets/country/Kenya.webp";
    case "Malaysia Tourist E-Visa":
      return "/assets/country/Malaysia.webp";
    case "Argentina Tourist E-Visa":
      return "/assets/country/Argentina.webp";
    case "UAE Tourist E-Visa":
      return "/assets/country/UAE.webp";
    case "Russia Tourist E-Visa":
      return "/assets/country/Russia.webp";
    case "Thailand Tourist E-Visa":
      return "/assets/country/Thailand.webp";
    case "Australia e Visitor Visa":
      return "/assets/country/Australia.webp";
    case "Australia dan Visa Pelawat":
      return "/assets/country/Australia.webp";
    case "India Tourist E-Visa":
      return "/assets/country/India.webp";
    case "India Business E-Visa":
      return "/assets/country/India5.webp";
    case "India Turisztikai E-Visa":
      return "/assets/country/India7.webp";
    case "E-Visa Pelancong India":
      return "/assets/country/India.webp";
    case "E-Visa Perniagaan India":
      return "/assets/country/India3.webp";
    case "New Zealand Tourist ETA":
      return "/assets/country/newZealand.webp";
    case "USA Tourist ESTA":
      return "/assets/country/USA.webp";
    case "USA Business ESTA":
      return "/assets/country/Usa1.webp";
    case "Canada Tourist ETA":
      return "/assets/country/Canada.webp";
    case "Turkey Tourist E-Visa":
      return "/assets/country/Turkey.webp";
    case "E-Visa Pelancong Bahrain":
      return "/assets/country/Bahrein.webp";
    case "E-Visa Pelancong Kuwait":
      return "/assets/country/Kuwait.webp";
    case "ETA Pelancong New Zealand":
      return "/assets/country/newZealand.webp";
    case "E-Visa Pelancong Rusia":
      return "/assets/country/Russia.webp";
    case "تأشيرة أرمينيا السياحية الإلكترونية":
      return "/assets/country/Turkey.webp";
    case "تأشيرة أذربيجان السياحية الإلكترونية":
      return "/assets/country/Russia.webp";
    case "تأشيرة جنوب إفريقيا السياحية الإلكترونية":
      return "/assets/country/newZealand.webp";
    case "تأشيرة فيتنام السياحية الإلكترونية":
      return "/assets/country/Vietnam.webp";
    case "تأشيرة لاوس السياحية الإلكترونية":
      return "/assets/country/Laos.webp";
    case "تأشيرة الهند السياحية الإلكترونية":
      return "/assets/country/India.webp";
    case "تأشيرة الهند الإلكترونية للأعمال":
      return "/assets/country/India8.webp";
    case "كندا السياحية ايتا":
      return "/assets/country/Canada.webp";
    case "Visa de tourisme pour l&#39;Arménie":
      return "/assets/country/Armenian.webp";
    case "Visa touristique électronique pour le Venezuela":
      return "/assets/country/venezuela.webp";
    case "تأشيرة كمبوديا السياحية الإلكترونية":
      return "/assets/country/Cambodia1.webp";
    case "تأشيرة الأعمال الإلكترونية في كمبوديا":
      return "/assets/country/Cambodia 2.webp";
    case "تأشيرة تايوان السياحية الإلكترونية":
      return "/assets/country/Taiwan.webp";
    case "تأشيرة سريلانكا السياحية الإلكترونية":
      return "/assets/country/Srilanka1.webp";
    case "تأشيرة مولدوفا السياحية الإلكترونية":
      return "/assets/country/Moldova1.webp";
    case "تأشيرة الأعمال الإلكترونية لسريلانكا":
      return "/assets/country/Srilanka2.webp";
    case "التأشيرة الإلكترونية السياحية لمصر":
      return "/assets/country/Egypt.webp";
    case "تأشيرة رومانيا السياحية الإلكترونية":
      return "/assets/country/Romania.webp";
    case "تأشيرة إندونيسيا السياحية الإلكترونية":
      return "/assets/country/Indonesia1.webp";
    case "تأشيرة تشيلي السياحية الإلكترونية":
      return "/assets/country/Chile.webp";
    case "تأشيرة عبور سريلانكا الإلكترونية":
      return "/assets/country/srilanka3.webp";
    case "تأشيرة كينيا السياحية الإلكترونية":
      return "/assets/country/Kenya.webp";
    case "المملكة المتحدة EVW":
      return "/assets/country/UnitedKingdom.webp";
    case "نيوزيلندا السياحية ETA":
      return "/assets/country/newZealand.webp";
    case "تأشيرة تركيا السياحية الإلكترونية":
      return "/assets/country/Turkey.webp";
    case "التأشيرة الإلكترونية السياحية لروسيا":
      return "/assets/country/Russia.webp";
    case "تأشيرة الأرجنتين السياحية الإلكترونية":
      return "/assets/country/Argentina.webp";
    case "تأشيرة كولومبيا السياحية الإلكترونية":
      return "/assets/country/Cambodia.webp";
    case "베트남 관광 e비자":
      return "/assets/country/Vietnam.webp";
    case "캄보디아 관광 E비자":
      return "/assets/country/Cambodia.webp";
    case "이집트 관광 E비자":
      return "/assets/country/Egypt.webp";
    case "아제르바이잔 관광 E비자":
      return "/assets/country/Azerbaijan.webp";
    case "바레인 관광 E비자":
      return "/assets/country/Bahrein.webp";
    case "케냐 관광 E비자":
      return "/assets/country/Kenya.webp";
    case "쿠웨이트 관광 E비자":
      return "/assets/country/Kuwait.webp";
    case "뉴질랜드 관광 ETA":
      return "/assets/country/newZealand.webp";
    case "미국 관광 ESTA 비자":
      return "/assets/country/USA.webp";
    case "인도네시아 관광 E비자":
      return "/assets/country/Indonesia1.webp";
    case "사우디아라비아 관광 E비자":
      return "/assets/country/Saudi_Arabia.webp";
    case "캐나다 관광 ETA":
      return "/assets/country/Canada.webp";
    case "호주 전자 방문 비자":
      return "/assets/country/Australia.webp";
    case "วีซ่าท่องเที่ยวอินเดีย E-Visa":
      return "/assets/country/India.webp";
    case "วีซ่าธุรกิจอินเดีย E-Visa":
      return "/assets/country/India6.webp";
    case "วีซ่าท่องเที่ยวศรีลังกา E-Visa":
      return "/assets/country/Srilanka2.webp";
    case "วีซ่าธุรกิจศรีลังกา E-Visa":
      return "/assets/country/srilanka3.webp";
    case "ศรีลังกาทรานสิท E-วีซ่า":
      return "/assets/country/srilanka4.webp";
    case "วีซ่าท่องเที่ยวโมร็อกโก E-Visa":
      return "/assets/country/Morocco.webp";
    case "วีซ่าท่องเที่ยวอาร์เมเนีย E-Visa":
      return "/assets/country/Armenian.webp";
    case "E-Visa ท่องเที่ยวมอลโดวา":
      return "/assets/country/Moldova.webp";
    case "E-Visa ท่องเที่ยวโรมาเนีย":
      return "/assets/country/Romania.webp";
    case "วีซ่าท่องเที่ยวโอมาน E-Visa":
      return "/assets/country/Oman.webp";
    case "วีซ่าท่องเที่ยวอาเซอร์ไบจาน E-Visa":
      return "/assets/country/Azerbaijan.webp";
    case "วีซ่าท่องเที่ยวบาห์เรน E-Visa":
      return "/assets/country/Bahrein.webp";
    case "วีซ่าท่องเที่ยวยูเครน E-Visa":
      return "/assets/country/Ukraine6.webp";
    case "ยูเครน Tourist E-Visa รายการด่วน":
      return "/assets/country/Ukraine2.webp";
    case "วีซ่าท่องเที่ยวยูเครนด่วน E-Visa":
      return "/assets/country/Ukraine3.webp";
    case "วีซ่าธุรกิจยูเครน E-Visa":
      return "/assets/country/Ukraine4.webp";
    case "E-Visa ธุรกิจด่วนของยูเครน":
      return "/assets/country/Ukraine5.webp";
    case "E-Visa ด่วนสำหรับธุรกิจยูเครน":
      return "/assets/country/Ukraine1.webp";
    case "วีซ่าท่องเที่ยวเคนยา E-Visa":
      return "/assets/country/Kenya.webp";
    case "UAE Transit E-Visa ดูไบ":
      return "/assets/country/uae2.jpeg";
    case "UAE Transit E-Visa":
      return "/assets/country/uae3.jpeg";
    case "E-Visa ท่องเที่ยวสหรัฐอาหรับเอมิเรตส์":
      return "/assets/country/UAE.webp";
    case "Kamboçya Turist E-Vizesi":
      return "/assets/country/Cambodia.webp";
    case "Kamboçya Ticari E-Vizesi":
      return "/assets/country/Cambodia1.webp";
    case "Sri Lanka Turist E-Vizesi":
      return "/assets/country/Srilanka.webp";
    case "Sri Lanka Transit E-Vizesi":
      return "/assets/country/Srilanka2.webp";
    case "Sri Lanka Ticari E-Vizesi":
      return "/assets/country/Srilanka1.webp";
    case "Kenya Turist E-Vizesi":
      return "/assets/country/Kenya.webp";
    case "Kuveyt Turist E-Vizesi":
      return "/assets/country/Kuwait.webp";
    case "BAE Turist E-Vizesi":
      return "/assets/country/UAE.webp";
    case "Rusya Turist E-Vizesi":
      return "/assets/country/Russia.webp";
    case "Visa electrónica de turista para Vietnam":
      return "/assets/country/Vietnam.webp";
    case "Visa electrónica de turista para Azerbaiyán":
      return "/assets/country/Azerbaijan.webp";
    case "Visa electrónica de turista para Baréin":
      return "/assets/country/Bahrein.webp";
    case "ETA turística de Nueva Zelanda":
      return "/assets/country/newZealand.webp";
    case "VISA ESTA de turista de EE. UU.":
      return "/assets/country/USA.webp";
    case "ETA turística de Canadá":
      return "/assets/country/Canada.webp";
    case "越南旅游电子签证":
      return "/assets/country/Vietnam.webp";
    case "柬埔寨旅游电子签证":
      return "/assets/country/Cambodia.webp";
    case "柬埔寨商务电子签证":
      return "/assets/country/Cambodia1.webp";
    case "斯里兰卡旅游电子签证":
      return "/assets/country/Srilanka.webp";
    case "斯里兰卡商务电子签证":
      return "/assets/country/Srilanka2.webp";
    case "斯里兰卡过境电子签证":
      return "/assets/country/srilanka3.webp";
    case "埃及旅游电子签证":
      return "/assets/country/Egypt.webp";
    case "阿塞拜疆旅游电子签证":
      return "/assets/country/Azerbaijan.webp";
    case "巴林旅游电子签证":
      return "/assets/country/Bahrein.webp";
    case "肯尼亚旅游电子签证":
      return "/assets/country/Kenya.webp";
    case "马来西亚旅游电子签证":
      return "/assets/country/Malaysia.webp";
    case "土耳其旅游电子签证":
      return "/assets/country/Turkey.webp";
    case "哥伦比亚旅游电子签证":
      return "/assets/country/Cambodia.webp";
    case "俄罗斯旅游电子签证":
      return "/assets/country/Russia.webp";
    case "USA Tourist ESTA VISA":
      return "/assets/country/USA.webp";
    case "Kanadan turisti-ETA":
      return "/assets/country/Canada.webp";
    case "Venäjän turisti E-Visa":
      return "/assets/country/Russia.webp";
    case "Kambodžan turisti E-Visa":
      return "/assets/country/Cambodia.webp";
    case "Intian turisti E-Visa":
      return "/assets/country/India.webp";
    case "Sri Lankan turisti-e-viisumi":
      return "/assets/country/Srilanka.webp";
    case "Egyptin turisti E-Visa":
      return "/assets/country/Egypt.webp";
    case "Egyptin turisti E-Visa":
      return "/assets/country/Egypt.webp";
    case "Azerbaidžanin turisti E-Visa":
      return "/assets/country/Azerbaijan.webp";
    case "Bahrain Tourist E-Visa":
      return "/assets/country/Bahrein.webp";
    case "Kenia Tourist E-Visa":
      return "/assets/country/Kenya.webp";
    case "Kuwait Tourist E-Visa":
      return "/assets/country/Kuwait.webp";
    case "Uuden-Seelannin turisti-ETA":
      return "/assets/country/newZealand.webp";
    case "E-Visa de turista vietnamita":
      return "/assets/country/Vietnam.webp";
    case "Visto eletrônico cambojano de turista":
      return "/assets/country/Cambodia.webp";
    case "Visto eletrônico indiano de turista":
      return "/assets/country/India.webp";
    case "E-Visa Sri Lanka de turista":
      return "/assets/country/Srilanka.webp";
    case "E-Visa Sri Lanka de turista":
      return "/assets/country/Srilanka.webp";
    case "E-Visa egípcio de turista":
      return "/assets/country/Egypt.webp";
    case "E-Visa de turista para o Azerbaijão":
      return "/assets/country/Azerbaijan.webp";
    case "E-Visa de turista para o Bahrein":
      return "/assets/country/Bahrein.webp";
    case "E-Visa queniano de turista":
      return "/assets/country/Kenya.webp";
    case "E-Visa queniano de turista":
      return "/assets/country/Kenya.webp";
    case "Turismo da Nova Zelândia ETA":
      return "/assets/country/newZealand.webp";
    case "Visa electrónica de turista para Camboya":
      return "/assets/country/Cambodia.webp";
    case "Visa electrónica de turista para India":
      return "/assets/country/India.webp";
    case "Visa electrónica de turista de Sri Lanka":
      return "/assets/country/Srilanka.webp";
    case "Visa electrónica de turista para Egipto":
      return "/assets/country/Egypt.webp";
    case "Visa de Visitante para Australia":
      return "/assets/country/Australia.webp";
    case "Visa electrónica de turista para Rusia":
      return "/assets/country/Russia.webp";
    case "Indian Tourist E-Visa":
      return "/assets/country/India4.webp";
    case "Indian Business E-Visa":
      return "/assets/blog2/India3.webp";

    default:
      return "/assets/country/India.webp";
  }
};
